import { CancelOutlined } from "@mui/icons-material";
import { useEffect } from "react";
import { useRef } from "react";
import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "./ARIMemberSearchForm.scss";
import { AppState } from "webapp/enums/AppState";
import "./ARIMemberSearchForm.scss";
import { Alert, fabClasses } from "@mui/material";
import { devLog } from "utils/devLog";

const defaultSearchType = "Last 8 digits of VIN";

function ARIMemberSearchForm(props) {
  const { t } = useTranslation();
  const formRef = useRef();
  const [last8VIN, setLast8VIN] = useState(props.last8VIN || "");
  const [licensePlate, setLicensePlate] = useState(props.licensePlate || "");
  // const [provinceCode, setProvinceCode] = useState(props.provinceCode || "");
  const [clientId, setClientId] = useState(props.ClientID || "");
  const [unitNo, setUnitNo] = useState(props.unitNo || "");
  const [serviceCardNum, setServiceCardNum] = useState(props.ServiceCardNum || "");
  const [odometer, setODometer] = useState(props.odometer || "");
  const [odometerMoreThan7, setOdometerMoreThan7] = useState(false);
  const [searchTypes, setSearchTypes] = useState([
    {
      key: "Last 8 digits of VIN",
      value: t("description.DropdownOptions1"),
    },
    {
      key: "License Plate & State / Province Code",
      value: t("description.DropdownOptions2"),
    },
    {
      key: "Client ID & Unit Number",
      value: t("description.DropdownOptions3"),
    },
  ]);

  const [selectedSearchType, setSelectedSearchType] = useState(defaultSearchType);
  const [moreThanEightVin, setMoreThanEightVin] = useState(false);
  const [lessEightVin, setLessEightVin] = useState(false);
  const [rightLengthVin, setRightLengthVin] = useState(false);

  const [moreThan4ClientId, setMoreThan4ClientId] = useState(false);
  // const [morethan5UnitNo, setMoreThan5UnitNo] = useState(false);
  // const [stateError, setStateError] = useState(false);
  // function changeValue(value) {
  //   this.setValue(value);
  // }

  // useEffect(() => {
  //   localStorage.setItem("selectedSearchType", selectedSearchType);
  // }, [selectedSearchType]);

  // useEffect(() => {
  //   localStorage.setItem("last8VIN", last8VIN);
  // }, [last8VIN]);

  // useEffect(() => {
  //   localStorage.setItem("licensePlate", licensePlate);
  // }, [licensePlate]);

  // useEffect(() => {
  //   localStorage.setItem("clientId", clientId);
  // }, [clientId]);

  // useEffect(() => {
  //   localStorage.setItem("unitNo", unitNo);
  // }, [unitNo]);

  // useEffect(() => {
  //   localStorage.setItem("odometer", odometer);
  // }, [odometer]);

  // useEffect(() => {
  //   try {
  //     const key = `${props.currState.providerRef}-searchQuery`;
  //     const searchQueryJSON = JSON.parse(
  //       localStorage.getItem(key, props.currState.providerRef)
  //     );

  //     setLast8VIN(searchQueryJSON?.last8VIN || props.last8VIN || "");
  //     setLicensePlate(
  //       searchQueryJSON?.licensePlate || props.licensePlate || ""
  //     );
  //     setClientId(searchQueryJSON?.clientId || props.ClientID || "");
  //     setUnitNo(searchQueryJSON?.unitNo || props.unitNo || "");
  //     // setServiceCardNum( searchQueryJSON?.ServiceCardNum || props.ServiceCardNum || "" );
  //     setODometer(searchQueryJSON?.odometer || props.odometer || "");
  //     setSelectedSearchType(
  //       searchQueryJSON?.selectedSearchType || defaultSearchType
  //     );
  //     setStateNameSelect(searchQueryJSON?.stateNameSelect || "State Name");
  //   } catch (e) {
  //     console.error(e);
  //   }
  // }, [selectedSearchType, last8VIN, licensePlate, clientId, unitNo, odometer]);

  useEffect(() => {
    // try {
    //   const key = `${props.currState.providerRef}-searchQuery`;
    //   const searchQueryJSON = JSON.parse(
    //     localStorage.setItem(key, props.currState.providerRef)
    //   );

    //   setLast8VIN(searchQueryJSON?.last8VIN || props.last8VIN || "");
    //   setLicensePlate(
    //     searchQueryJSON?.licensePlate || props.licensePlate || ""
    //   );
    //   setClientId(searchQueryJSON?.clientId || props.ClientID || "");
    //   setUnitNo(searchQueryJSON?.unitNo || props.unitNo || "");
    //   // setServiceCardNum( searchQueryJSON?.ServiceCardNum || props.ServiceCardNum || "" );
    //   setODometer(searchQueryJSON?.odometer || props.odometer || "");
    //   setSelectedSearchType(
    //     searchQueryJSON?.selectedSearchType || defaultSearchType
    //   );
    //   setStateNameSelect(searchQueryJSON?.stateNameSelect || "State Name");
    // } catch (e) {
    //   console.error(e);
    // }

    if (typeof props.onFormUpdated === "function") {
      props.onFormUpdated({
        last8VIN: last8VIN,
        licensePlate: licensePlate,
        provinceCode: stateLookup(stateNameSelect),
        clientId: clientId,
        unitNo: unitNo,
        serviceCardNum: serviceCardNum,
        odometer: odometer,
        searchType: selectedSearchType,
      });
    }
  }, []);

  // const [moreThan6unitNum, setMoreThan6UnitNum] = useState(false);
  // const [lessThan6unitNum, setLessThan6UnitNum] = useState(false);
  const [rightUnitNum, setRightUnitNum] = useState(true);

  const unitNumIdInputLength = (unitNo) => {
    setRightUnitNum(true);
    let uLen = unitNo.length;
    devLog("uLen: " + uLen);
    if (uLen === 5 || uLen === 6) {
      setRightUnitNum(true);
      return true;
    } else {
      setRightUnitNum(false);
      return false;
    }
  };

  const vinInputLength = (last8VIN) => {
    let vin = last8VIN.length;
    if (vin < 8) {
      setLessEightVin(true);
      return false;
    } else if (vin > 8) {
      setMoreThanEightVin(true);
      return false;
    }
    setRightLengthVin(true);
    return true;
  };

  const onSubmit = (e) => {
    devLog("onSubmit", e);
    e.preventDefault();
    if (selectedSearchType === "Last 8 digits of VIN") {
      const bSuccess = vinInputLength(last8VIN);
      if (!bSuccess) {
        devLog("rightLengthVin: " + last8VIN);
        return;
      }
    }
    if (selectedSearchType === "Client ID & Unit Number") {
      let bSuccess = unitNumIdInputLength(unitNo);
      if (!bSuccess) {
        devLog("rightUnitNum: " + unitNo);
        return;
      }
    }
    if (typeof props.onFormSubmit === "function") {
      props.onFormSubmit({
        last8VIN: last8VIN,
        licensePlate: licensePlate,
        provinceCode: stateLookup(stateNameSelect),
        clientId: clientId,
        unitNo: unitNo,
        serviceCardNum: serviceCardNum,
        odometer: odometer,
        searchType: selectedSearchType,
      });
    }
    return false;
  };

  const odometerInputLength = (e) => {
    if (e.target.value.length > 6) {
      e.target.value = e.target.value.slice(0, -1);
      setOdometerMoreThan7(true);
      devLog("Odometer is more than 1,000,000");
    }
  };

  const clientIdInputLength = (e) => {
    if (e.target.value.length > 4) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThan4ClientId(true);
      devLog("Client ID length error");
    }
  };

  const limitLenVin = (e) => {
    if (e.target.value.length > 8) {
      e.target.value = e.target.value.slice(0, -1);
      setMoreThanEightVin(true);
    }
  };
  const limitLenUnitNum = (e) => {
    setRightUnitNum(true);
    if (e.target.value.length > 6) {
      e.target.value = e.target.value.slice(0, -1);
      setRightUnitNum(false);
    }
  };

  // const stateCheck = (e) => {

  //   if (e.target.value === "State Name") {

  //     setStateError(true);

  //     devLog("State Name error");

  //   }

  //   return stateError;

  // };

  const [stateNameSelect, setStateNameSelect] = useState("State Name");
  const [stateName, setStateName] = useState([
    { abbreviation: "AL", name: "Alabama" },
    { abbreviation: "AK", name: "Alaska" },
    { abbreviation: "AZ", name: "Arizona" },
    { abbreviation: "AR", name: "Arkansas" },
    { abbreviation: "CA", name: "California" },
    { abbreviation: "CO", name: "Colorado" },
    { abbreviation: "CT", name: "Connecticut" },
    { abbreviation: "DE", name: "Delaware" },
    { abbreviation: "FL", name: "Florida" },
    { abbreviation: "GA", name: "Georgia" },
    { abbreviation: "HI", name: "Hawaii" },
    { abbreviation: "ID", name: "Idaho" },
    { abbreviation: "IL", name: "Illinois" },
    { abbreviation: "IN", name: "Indiana" },
    { abbreviation: "IA", name: "Iowa" },
    { abbreviation: "KS", name: "Kansas" },
    { abbreviation: "KY", name: "Kentucky" },
    { abbreviation: "LA", name: "Louisiana" },
    { abbreviation: "ME", name: "Maine" },
    { abbreviation: "MD", name: "Maryland" },
    { abbreviation: "MA", name: "Massachusetts" },
    { abbreviation: "MI", name: "Michigan" },
    { abbreviation: "MN", name: "Minnesota" },
    { abbreviation: "MS", name: "Mississippi" },
    { abbreviation: "MO", name: "Missouri" },
    { abbreviation: "MT", name: "Montana" },
    { abbreviation: "NE", name: "Nebraska" },
    { abbreviation: "NV", name: "Nevada" },
    { abbreviation: "NH", name: "New Hampshire" },
    { abbreviation: "NJ", name: "New Jersey" },
    { abbreviation: "NM", name: "New Mexico" },
    { abbreviation: "NY", name: "New York" },
    { abbreviation: "NC", name: "North Carolina" },
    { abbreviation: "ND", name: "North Dakota" },
    { abbreviation: "OH", name: "Ohio" },
    { abbreviation: "OK", name: "Oklahoma" },
    { abbreviation: "OR", name: "Oregon" },
    { abbreviation: "PA", name: "Pennsylvania" },
    { abbreviation: "RI", name: "Rhode Island" },
    { abbreviation: "SC", name: "South Carolina" },
    { abbreviation: "SD", name: "South Dakota" },
    { abbreviation: "TN", name: "Tennessee" },
    { abbreviation: "TX", name: "Texas" },
    { abbreviation: "UT", name: "Utah" },
    { abbreviation: "VT", name: "Vermont" },
    { abbreviation: "VA", name: "Virginia" },
    { abbreviation: "WA", name: "Washington" },
    { abbreviation: "WV", name: "West Virginia" },
    { abbreviation: "WI", name: "Wisconsin" },
    { abbreviation: "WY", name: "Wyoming" },
  ]);

  const [stateNameCA, setStateNameCA] = useState([
    { abbreviation: "AB", name: "Alberta" },
    { abbreviation: "BC", name: "British Columbia" },
    { abbreviation: "MB", name: "Manitoba" },
    { abbreviation: "NB", name: "New Brunswick" },
    { abbreviation: "NL", name: "Newfoundland and Labrador" },
    { abbreviation: "NS", name: "Nova Scotia" },
    { abbreviation: "NT", name: "Northwest Territories" },
    { abbreviation: "NU", name: "Nunavut" },
    { abbreviation: "ON", name: "Ontario" },
    { abbreviation: "PE", name: "Prince Edward Island" },
    { abbreviation: "QC", name: "Quebec" },
    { abbreviation: "SK", name: "Saskatchewan" },
    { abbreviation: "YU", name: "Yukon" },
  ]);

  const stateLookup = (input) => {
    var stateOutput = "";
    stateName.map((item) => {
      if (item.name === input) {
        stateOutput = item.abbreviation;
      }

      return null;
    });

    return stateOutput;
  };

  return (
    <>
      <div className="formContainer">
        <div style={{ fontSize: "30px" }}></div>

        <form ref={formRef} onSubmit={onSubmit} className="form">
          <Dropdown
            style={{
              display: "flex",

              justifyContent: "center",

              marginTop: "10px",
            }}
          >
            <Dropdown.Toggle style={{ color: "white" }} variant="dark" id="dropdown-basic">
              {searchTypes.find((opt) => opt.key === selectedSearchType)?.value}
            </Dropdown.Toggle>

            <Dropdown.Menu variant="dark">
              {searchTypes.map((searchType) => {
                return (
                  <Dropdown.Item
                    active={searchType.key === selectedSearchType}
                    onClick={(e) => {
                      e.preventDefault();
                      setSelectedSearchType(searchType.key);
                    }}
                  >
                    {searchType.value}
                  </Dropdown.Item>
                );
              })}
            </Dropdown.Menu>
          </Dropdown>

          {/* Last 8 VIN */}

          {selectedSearchType === "Last 8 digits of VIN" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerLast8VIN1")}:</div>

                <input
                  type="text"
                  placeholder={t("description.ConfirmCustomerLast8VIN2")}
                  name="l8vin"
                  className="input form-control required"
                  value={last8VIN}
                  onChange={(e) => {
                    // setMoreThanEightVin(false);
                    // vinInputLength(e);
                    setLessEightVin(false);
                    setMoreThanEightVin(false);
                    limitLenVin(e);
                    setLast8VIN(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>

              {/* {moreThanEightVin && (
                <Alert severity="error">
                  {t("description.VinInputErrorMsg")}
                </Alert>
              )} */}
              {lessEightVin && <Alert severity="error">{t("description.VinInputLessErrorMsg")}</Alert>}
            </>
          )}

          {/* {moreThanEightVin && alert("Please enter the last 8 of your VIN")} */}

          {/* License Plate Number */}

          {selectedSearchType === "License Plate & State / Province Code" && (
            <div className="group-1">
              <div className="label">{t("description.ConfirmCustomerLicensePlate1")}:</div>

              <input
                type="text"
                placeholder={t("description.ConfirmCustomerLicensePlate1")}
                name="License Plate"
                className="input form-control required"
                value={licensePlate}
                onChange={(e) => {
                  setLicensePlate(e.target.value?.toUpperCase()?.trim() || "");
                }}
                required
              />
            </div>
          )}

          {/* Province Code */}

          {selectedSearchType === "License Plate & State / Province Code" && (
            <div className="group-1">
              <div className="label">{t("description.ConfirmCustomerProvinceCode1")}:</div>

              {/* <input

                type="text"

                placeholder={t("description.ConfirmCustomerProvinceCode2")}

                name="provinceCode"

                className="input form-control required"

                value={provinceCode}

                onChange={(e) => {

                  setProvinceCode(e.target.value?.toUpperCase()?.trim() || "");

                }}

                required

              /> */}

              <div className="input required">
                {/* USA Case */}

                {props.partner === "ARIU" && (
                  <Dropdown>
                    <Dropdown.Toggle style={{ color: "black" }} variant="light" id="dropdown-basic">
                      {stateNameSelect}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      variant="light"
                      style={{
                        overflow: "auto",

                        maxHeight: "150px",
                      }}
                    >
                      {stateName.map((stateName) => {
                        return (
                          <Dropdown.Item
                            active={stateName.name === stateNameSelect}
                            onClick={
                              (e) => setStateNameSelect(stateName.name)

                              // check(e.value);l
                            }
                          >
                            {stateName.name}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                )}

                {/* Canada Case */}

                {props.partner === "ARIC" && (
                  <Dropdown>
                    <Dropdown.Toggle style={{ color: "black" }} variant="light" id="dropdown-basic">
                      {stateNameSelect}
                    </Dropdown.Toggle>

                    <Dropdown.Menu
                      variant="light"
                      style={{
                        overflow: "auto",

                        maxHeight: "150px",
                      }}
                    >
                      {stateNameCA.map((stateNameCA) => {
                        return (
                          <Dropdown.Item
                            active={stateNameCA.name === stateNameSelect}
                            onClick={
                              (e) => setStateNameSelect(stateNameCA.name)

                              // check(e.value);
                            }
                          >
                            {stateNameCA.name}
                          </Dropdown.Item>
                        );
                      })}
                    </Dropdown.Menu>
                  </Dropdown>
                )}
              </div>
            </div>
          )}

          {/* Cient ID */}

          {selectedSearchType === "Client ID & Unit Number" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerClientID1")}:</div>
                <input
                  type="text"
                  placeholder={t("description.ConfirmCustomerClientID1")}
                  name="clientID"
                  className="input form-control required"
                  value={clientId}
                  onChange={(e) => {
                    setMoreThan4ClientId(false);

                    clientIdInputLength(e);

                    setClientId(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>

              {moreThan4ClientId && <Alert severity="error">{t("description.ClientIdError")}</Alert>}
            </>
          )}

          {/* Unit Number */}
          {selectedSearchType === "Client ID & Unit Number" && (
            <>
              <div className="group-1">
                <div className="label">{t("description.ConfirmCustomerUnitNo1")}:</div>

                <input
                  type="number"
                  placeholder={t("description.ConfirmCustomerUnitNo2")}
                  name="unitNo"
                  className="input form-control required"
                  value={unitNo}
                  onChange={(e) => {
                    // setMoreThan6UnitNum(false);
                    // lessThan6unitNum(false);
                    // unitNumIdInputLength(e);
                    // setLessThan6UnitNum(false);
                    // setMoreThan6UnitNum(false);
                    limitLenUnitNum(e);
                    setUnitNo(e.target.value?.toUpperCase()?.trim() || "");
                  }}
                  required
                />
              </div>

              {!rightUnitNum && <Alert severity="error">{t("description.UnitNumberLong")}</Alert>}
            </>
          )}

          {/* Service Card Number */}

          {/* {selectedSearchType === t("description.DropdownOptions4") && (

            <div className="group-1">

              <div className="label">

                {t("description.ConfirmCustomerServiceCardNum1")}:

              </div>

              <input

                type="text"

                placeholder={t("description.ConfirmCustomerServiceCardNum2")}

                name="serviceCardNum"

                className="input form-control required"

                value={serviceCardNum}

                onChange={(e) => {

                  setServiceCardNum(

                    e.target.value?.toUpperCase()?.trim() || ""

                  );

                }}

                required

              />

            </div>

          )} */}

          {/* Odometer*/}

          <>
            <div className="group-1">
              <div className="label">{t("description.ConfirmCustomerOdometer1")}:</div>
              <input
                type="number"
                placeholder={t("description.ConfirmCustomerOdometer2")}
                name="Odometer"
                className="input form-control required"
                value={odometer}
                onChange={(e) => {
                  setOdometerMoreThan7(false);
                  odometerInputLength(e);
                  setODometer(e.target.value?.toUpperCase()?.trim() || "");
                }}
                required
              />
            </div>

            {odometerMoreThan7 && <Alert severity="error">{t("description.OdometerInputErrorMsg")}</Alert>}
          </>

          <div className="footerContainer">
            <div>
              <button
                id="cancelButton"
                type="button"
                className="footer"
                style={{
                  background: "#f4f4f4",

                  color: "black",

                  paddingLeft: 14,
                }}
                onClick={(e) => {
                  e.preventDefault();

                  devLog("UI Cancel pressed");

                  if (typeof props.onUserCancel === "function") {
                    props.onUserCancel();
                  }
                }}
              >
                <CancelOutlined style={{ width: 20, color: "black", marginRight: 4 }} />

                <span style={{ marginLeft: "0px" }}>{t("description.CancelCallButton1")}</span>
              </button>
            </div>

            <button type="submit" className="ui-btn">
              {t("description.ConfirmCustomerSubmit")}
            </button>
          </div>
        </form>
      </div>
    </>
  );
}

export default ARIMemberSearchForm;
